import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { text } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { spacing } from "@/theme/variables";
import { TipsBox } from "@/features/mock-exam/components/mock-exam/TipsBox";
import { MockExamGradeGuideCard } from "@/features/mock-exam/components/grade-guide";

type OverviewDetailsProps = {
  metadata: {
    totalQuestions: number;
    timeLimitMinutes: number;
    passingScorePercentage: number;
  };
};

export const OverviewDetails: FC<OverviewDetailsProps> = ({ metadata }) => {
  const { t } = useTranslation();
  return (
    <>
      <Stack minHeight={96} gap={spacing.smd}>
        <Typography sx={{ ...typography.body14Bold, color: text.primary }}>{t("mockExam.overview")}</Typography>
        <Stack gap={spacing.xxs}>
          <Typography sx={{ ...typography.body14Semi, color: text.secondary }}>
            ・ {t("mockExam.metadata.totalQuestions")} : {t("mockExam.metadata.totalQuestionsValue", { totalQuestions: metadata.totalQuestions })}
          </Typography>
          <Typography sx={{ ...typography.body14Semi, color: text.secondary }}>
            ・ {t("mockExam.metadata.timeLimitMinutes")} : {t("mockExam.metadata.timeLimitValue", { timeLimit: metadata.timeLimitMinutes })}
          </Typography>
          <Typography sx={{ ...typography.body14Semi, color: text.secondary }}>
            ・ {t("mockExam.metadata.passingScorePercentage")} :{" "}
            {t("mockExam.metadata.passingScoreValue", {
              percent: metadata.passingScorePercentage,
            })}
          </Typography>
        </Stack>
      </Stack>
      {metadata.passingScorePercentage > 0 && <MockExamGradeGuideCard passingScorePercentage={metadata.passingScorePercentage} />}
      <TipsBox />
    </>
  );
};
